<template>
    <div
        class="info-bar position-relative d-flex"
        :style="infoBarStyle"
    >
        <div
            class="background w-100 h-100 position-absolute"
            :class="backgroundClass"
        />
        <i
            class="icon far w-auto"
            :class="iconClass"
        />

        <div class="text mb-0 ml-2">
            <slot />
        </div>
    </div>
</template>

<script>
    import "./InfoBar.scss";

    export default {
        name: "InfoBar",

        props: {
            color: {
                type: String,
                required: true,
            },
            borderColor: {
                type: String,
                required: true,
            },

            icon: {
                type: String,
                required: true,
            },
        },

        computed: {
            infoBarStyle() {
                return {
                    borderColor: this.borderColor
                };
            },
            backgroundClass() {
                return 'bg-' + this.color;
            },

            iconClass() {
                return this.icon + ' text-' + this.color;
            },
        }
    };
</script>
